import "./GetAQuote.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import CollaborateWithUs from "./sections/CollaborateWithUs";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function GetAQuotePage() {
  return <div>
      <FraternalExcellenceHeader />
      <CollaborateWithUs />
      <Faq />
      <Footer />
    </div>;
}